import React from 'react';
import { withRouter } from 'react-router-dom';
import { viewToken, joinWithToken, getLeague } from '../data/leagues';
import { withStyles, CircularProgress, Typography, Button, Card, CardContent } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { isLoggedIn } from '../data';
import { Login } from './login';

const useStyles = (theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
    },
    container: {
        alignSelf: 'center',
        flex: 'auto',
        textAlign: 'left',
        maxWidth: 800,
    },
    header: {
        flexBasis: '100%',
    },
    content: {
        textAlign: 'left',
    },
    checkbox: {
        selfAlign: 'end',
    }
});

class ViewTokenInternl extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isRecognized: false,
        };
        this.joinTeam = this.joinTeam.bind(this);
        this.getTokenCode = this.getTokenCode.bind(this);
        this.loadTokenCode = this.loadTokenCode.bind(this);
    }

    async componentDidMount() {
        this.loadTokenCode();
    }

    async loadTokenCode() {
        const isRecognized = await isLoggedIn();
        const tokenCode = this.getTokenCode();
        this.setState(() => ({
            ...this.state,
            isRecognized: isRecognized,
        }));
        if (!isRecognized) {
            return;
        }
        this.setState(() => ({
            ...this.state,
            loading: true,
            tokenCode: tokenCode,
            isRecognized: isRecognized,
        }));
        try {
            const data = await viewToken(tokenCode);
            const leagueData = await getLeague(data['leagueID']);
            this.setState(() => ({
                ...this.state,
                loading: false,
                tokenData: data,
                league: leagueData,
            }));
        } catch (err) {
            this.setState(() => ({
                ...this.state,
                loading: false,
                serverError: 'Error getting invite token data - ' + err.message,
            }));
        }
    }

    getTokenCode() {
        if (this.props.match.params.tokenCode) {
            return this.props.match.params.tokenCode;
        } else if (this.state.tokenCode) {
            return this.state.tokenCode;
        } else if (document.getElementById('invite-code')) {
            return document.getElementById('invite-code').value;
        }
        return undefined;
    }

    async joinTeam() {
        const tokenCode = this.getTokenCode();
        try {
            const data = await joinWithToken(tokenCode);
            if (data.error) {
                this.setState(() => ({
                    ...this.state,
                    loading: false,
                    serverError: 'Error joining league - ' + data.error,
                }));
            } else {
                this.props.history.push(`/leagues/${data.leagueID}`);
            }
        } catch (err) {
            this.setState(() => ({
                ...this.state,
                loading: false,
                serverError: 'Error joining league - ' + err.message,
            }));
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
            <Card className={classes.container}>
            {this.state.isRecognized && 
            <CardContent>
                {this.state.loading && <CircularProgress />}
                {this.state.serverError &&
                <Alert severity="error">
                    <AlertTitle>Server Error</AlertTitle>
                    {this.state.serverError}
                </Alert>
                }
                {this.state.tokenData !== undefined && this.state.league !== undefined &&
                <div>
                    <Typography>
                    League name: {this.state.league.name}
                    </Typography>
                    {this.state.tokenData.type === 'squad' &&
                    <div>
                        <Typography>
                            Squad Name: {this.state.tokenData.squadName}
                        </Typography>
                        <Button color='primary' variant="contained" onClick={(e) => this.joinTeam(e)}>
                            Join league
                        </Button>
                    </div>
                    }
                    {this.state.tokenData.type === 'admin' &&
                    <div>
                        <Button color='primary' variant="contained" onClick={(e) => this.joinTeam(e)}>
                            Join league as admin
                        </Button>
                    </div>
                    }
                </div>
                }
            </CardContent>
            }
            {!this.state.isRecognized && <Login setRecognized={this.loadTokenCode} />}
            </Card>
            </div>
        );
    }
}
export const ViewToken = withStyles(useStyles)(withRouter(ViewTokenInternl));